import { Link } from 'react-router-dom';

export default function ServicesGrid() {
  const services = [
    {
      slug: 'emergency-work',
      title: 'Emergency Work',
      description: '24/7 emergency electrical services for urgent repairs and safety issues',
      icon: 'ri-alarm-warning-line',
      image: 'https://public.readdy.ai/ai/img_res/64b973ba6cb23e3e308850137828bced.jpg'
    },
    {
      slug: 'ceiling-fans',
      title: 'Ceiling Fans',
      description: 'Professional ceiling fan installation, repair, and replacement services',
      icon: 'ri-contrast-drop-2-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20ceiling%20fan%20being%20installed%20by%20professional%20electrician%20in%20contemporary%20Sydney%20home%2C%20clean%20white%20ceiling%20with%20elegant%20fan%20design%2C%20bright%20natural%20lighting%2C%20professional%20installation%20service%20photography&width=800&height=600&seq=service-ceiling-fans-001&orientation=landscape'
    },
    {
      slug: 'power-points',
      title: 'Power Points',
      description: 'Installation and repair of power points, outlets, and USB charging stations',
      icon: 'ri-plug-line',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20installing%20modern%20power%20point%20outlet%20in%20clean%20white%20wall%2C%20close-up%20of%20professional%20installation%20work%20with%20tools%20visible%2C%20bright%20clean%20workspace%2C%20technical%20precision%20photography%20style&width=800&height=600&seq=service-power-points-001&orientation=landscape'
    },
    {
      slug: 'fault-detection',
      title: 'Fault Detection',
      description: 'Advanced electrical fault finding and diagnostic services',
      icon: 'ri-search-eye-line',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20using%20digital%20multimeter%20and%20diagnostic%20equipment%20to%20detect%20electrical%20fault%2C%20professional%20testing%20tools%20and%20safety%20equipment%20visible%2C%20technical%20precision%20and%20problem-solving%20focus%2C%20professional%20service%20photography&width=800&height=600&seq=service-fault-detection-001&orientation=landscape'
    },
    {
      slug: 'smoke-alarms',
      title: 'Smoke Alarms',
      description: 'Smoke alarm installation, testing, and compliance services',
      icon: 'ri-fire-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrician%20installing%20modern%20smoke%20alarm%20on%20white%20ceiling%2C%20safety%20equipment%20and%20testing%20tools%20visible%2C%20clean%20residential%20setting%2C%20safety%20and%20compliance%20focus%2C%20professional%20installation%20photography&width=800&height=600&seq=service-smoke-alarms-001&orientation=landscape'
    },
    {
      slug: 'lighting',
      title: 'Lighting Solutions',
      description: 'Indoor and outdoor lighting design, installation, and upgrades',
      icon: 'ri-lightbulb-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20LED%20lighting%20installation%20in%20contemporary%20Sydney%20home%2C%20elegant%20recessed%20lights%20and%20pendant%20fixtures%2C%20warm%20ambient%20lighting%20creating%20beautiful%20atmosphere%2C%20professional%20lighting%20design%20photography&width=800&height=600&seq=service-lighting-001&orientation=landscape'
    },
    {
      slug: 'electrical-repairs',
      title: 'Electrical Repairs',
      description: 'Expert repairs for all types of electrical faults and issues',
      icon: 'ri-tools-line',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20repairing%20electrical%20wiring%20with%20professional%20tools%2C%20focused%20work%20on%20electrical%20repair%20with%20safety%20equipment%20visible%2C%20clean%20workspace%20with%20electrical%20components%2C%20professional%20repair%20service%20photography&width=800&height=600&seq=service-repairs-001&orientation=landscape'
    },
    {
      slug: 'wiring-rewiring',
      title: 'Wiring & Rewiring',
      description: 'Complete wiring and rewiring services for homes and businesses',
      icon: 'ri-git-branch-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrical%20wiring%20installation%20showing%20organized%20cable%20management%20and%20modern%20electrical%20infrastructure%2C%20clean%20professional%20installation%20work%2C%20technical%20precision%20and%20quality%20craftsmanship%2C%20professional%20service%20photography&width=800&height=600&seq=service-wiring-001&orientation=landscape'
    },
    {
      slug: 'surge-protection',
      title: 'Surge Protection',
      description: 'Protect your valuable electronics with professional surge protection',
      icon: 'ri-shield-flash-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20surge%20protection%20device%20being%20installed%20in%20electrical%20panel%2C%20professional%20electrical%20safety%20equipment%2C%20clean%20technical%20installation%20showing%20protection%20systems%2C%20professional%20service%20photography%20with%20safety%20focus&width=800&height=600&seq=service-surge-001&orientation=landscape'
    },
    {
      slug: 'switchboards',
      title: 'Switchboards',
      description: 'Switchboard upgrades, repairs, and safety switch installation',
      icon: 'ri-dashboard-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20electrical%20switchboard%20with%20organized%20circuit%20breakers%20and%20safety%20switches%2C%20professional%20electrical%20panel%20installation%2C%20clean%20technical%20setup%20showing%20quality%20workmanship%2C%20professional%20electrical%20service%20photography&width=800&height=600&seq=service-switchboards-001&orientation=landscape'
    },
    {
      slug: 'electrical-maintenance',
      title: 'Electrical Maintenance',
      description: 'Regular maintenance and safety inspections for peace of mind',
      icon: 'ri-settings-3-line',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20performing%20electrical%20safety%20inspection%20with%20checklist%20and%20testing%20equipment%2C%20professional%20maintenance%20service%20in%20clean%20residential%20setting%2C%20safety%20and%20preventive%20care%20focus%2C%20professional%20service%20photography&width=800&height=600&seq=service-maintenance-001&orientation=landscape'
    },
    {
      slug: 'solar-batteries',
      title: 'Solar Batteries',
      description: 'Solar battery installation and integration for energy independence',
      icon: 'ri-battery-charge-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20solar%20battery%20storage%20system%20installation%20in%20clean%20garage%20or%20utility%20room%2C%20professional%20electrical%20connection%20to%20solar%20panels%2C%20sustainable%20energy%20technology%2C%20professional%20installation%20photography%20with%20clean%20technical%20focus&width=800&height=600&seq=service-solar-001&orientation=landscape'
    }
  ];

  return (
    <section className="py-14 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#535669] mb-3 md:mb-4">
            What We <span className="text-[#f67f19]">Offer</span>
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Professional electrical services backed by our lifetime guarantee
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => (
            <Link
              key={service.slug}
              to={`/services/${service.slug}`}
              className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-40 md:h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-3 md:bottom-4 left-3 md:left-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#f67f19] rounded-full flex items-center justify-center">
                    <i className={`${service.icon} text-white text-xl md:text-2xl`}></i>
                  </div>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-bold text-[#535669] mb-2 group-hover:text-[#f67f19] transition-colors">
                  {service.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 mb-3 md:mb-4 leading-relaxed">
                  {service.description}
                </p>
                <div className="flex items-center text-[#f67f19] font-bold text-sm group-hover:gap-2 transition-all">
                  <span>Learn More</span>
                  <i className="ri-arrow-right-line ml-1 group-hover:ml-0 transition-all"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}